import { isValidSchema } from "../util";
import { CaptureSystem } from "../capturesystem";
import { FrameDataMeta } from "../framedatameta";
import { Campaign } from "../campaign";
import { Spatial } from "../../../geo/Spatial";
import proj4 from "proj4";
export class Frame {
    constructor(id, key, collection, stream, streamtype, segment, framenumber, projection, timestamp, images, playmode, longitude, latitude, height, omega, phi, kappa, precLongitude, precLatitude, precHeight, precOmega, precPhi, precKappa, capturesystemID, framedatametaID, campaignID, capturesystem, framedatameta, campaign, epsg, epsgHeight, dataPath) {
        this.id = id;
        this.key = key;
        this.collection = collection;
        this.stream = stream;
        this.streamtype = streamtype;
        this.segment = segment;
        this.framenumber = framenumber;
        this.projection = projection;
        this.timestamp = timestamp;
        this.images = images;
        this.playmode = playmode;
        this.longitude = longitude;
        this.latitude = latitude;
        this.height = height;
        this.omega = omega;
        this.phi = phi;
        this.kappa = kappa;
        this.precLongitude = precLongitude;
        this.precLatitude = precLatitude;
        this.precHeight = precHeight;
        this.precOmega = precOmega;
        this.precPhi = precPhi;
        this.precKappa = precKappa;
        this.capturesystemID = capturesystemID;
        this.framedatametaID = framedatametaID;
        this.campaignID = campaignID;
        this.capturesystem = capturesystem;
        this.framedatameta = framedatameta;
        this.campaign = campaign;
        this.epsg = epsg;
        this.epsgHeight = epsgHeight;
        this.dataPath = dataPath;
    }
    static create(payload, collection) {
        const wgs84_coords = proj4(`EPSG:${payload.epsg}`, "EPSG:4326", {
            x: payload.easting,
            y: payload.northing,
            z: payload.height,
        });
        const opk = Spatial.rotToWGS84({ easting: payload.easting, northing: payload.northing, height: payload.height }, { omega: payload.omega, phi: payload.phi, kappa: payload.kappa }, payload.epsg);
        const std_opk = Spatial.rotToWGS84({ easting: payload.easting, northing: payload.northing, height: payload.height }, { omega: payload.precOmega, phi: payload.precPhi, kappa: payload.precKappa }, payload.epsg);
        const dir_split = payload.framedatameta.streamingdirectory.split("/");
        // Remove leading /
        if (dir_split[0] == "") {
            dir_split.splice(0, 1);
        }
        // Remove dat/ if exists
        if (dir_split[0] == "dat") {
            dir_split.splice(0, 1);
        }
        payload.framedatameta.streamingdirectory = dir_split.join("/");
        const dataPath = `${payload.framedatameta.streamingdirectory}/${payload.id.replace("-", "/")}`;
        return new Frame(payload.id, `${collection}/${payload.id}`, collection, payload.stream, payload.streamtype, payload.segment, payload.framenumber, payload.projection, payload.timestamp, payload.images, payload.playmode, wgs84_coords.x, wgs84_coords.y, payload.height, opk.omega, opk.phi, opk.kappa, payload.precEasting, payload.precNorthing, payload.precHeight, std_opk.omega, std_opk.phi, std_opk.kappa, payload.capturesystemID, payload.framedatametaID, payload.campaignID, payload.capturesystem ? CaptureSystem.create(payload.capturesystem) : undefined, payload.framedatameta ? FrameDataMeta.create(payload.framedatameta) : undefined, payload.campaign ? Campaign.create(payload.campaign) : undefined, payload.epsg, payload.epsgHeight, dataPath);
    }
    static isValid(payload) {
        const schema = [
            "id",
            "stream",
            "streamtype",
            "segment",
            "framenumber",
            "projection",
            "timestamp",
            "images",
            "playmode",
            "easting",
            "northing",
            "height",
            "omega",
            "phi",
            "kappa",
            "capturesystemID",
            "framedatametaID",
            "campaignID",
            "capturesystem",
            "framedatameta",
            "campaign",
        ];
        return (isValidSchema(payload, schema) &&
            CaptureSystem.isValid(payload.capturesystem) &&
            FrameDataMeta.isValid(payload.framedatameta));
    }
}
//# sourceMappingURL=frame.js.map